export default __webpack_public_path__ + "static/media/github-dependabot.a00b0d4f.svg";